<template>
  <div>
    <!-- tab结束 -->
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
     <template v-slot:orgIds>
        <el-select
          multiple
          filterable
          v-model="filters.OrgIds"
          placeholder="请选择"
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseIDs>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseIDs"
          placeholder="请选择仓库"
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:status>
        <selectAllVue
          :selectOptions="statuslist"
          :mulSelecteds="filters.status"
          @update:updateMultipleSelect="(val) => (filters.status = val)"
        />
        <!-- <el-select
          multiple
          filterable
          v-model="filters.status"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in statuslist"
            :label="item.outboundText"
            :value="item.outboundId"
            :key="item.outboundId"
          ></el-option>
        </el-select> -->
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template slot-scope="scope" slot="outboundNo">
        <hoverCopy>
          <el-link
            slot="referenceChild"
            :underline="false"
            type="primary"
            @click.native="viewloadingReviewdialog(scope.row)"
            >{{ scope.row.outboundNo }}
          </el-link>
        </hoverCopy>
      </template>

      <template slot-scope="scope" slot="file">
        <div>
          <span v-if="scope.row.pictureUrl !='' && scope.row.pictureUrl != null">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.actualEntryDataId)"
            >
              预览
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="abnormal">
        <div>
          <span v-if="scope.row.isAbnormal == true" style="color: red">
            {{ scope.row.isAbnormalText }}
          </span>
          <span v-else> {{ scope.row.isAbnormalText }}</span>
        </div>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 36, businessCode: currentRow.outboundNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
    <!-- 装车单 -->
    <el-dialog
      id="completeDialog"
      title="出库单"
      :visible.sync="addTaskdialogVisible"
      width="90%"
      top="70px"
      style="text-align: center"
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="700"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog>

    <!-- 打印装车单 -->
    <el-dialog
      :visible.sync="printPickListVisible"
      v-model="printPickListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      class="printDalog"
      title="打印拣货单"
      width="70%"
      style="text-align: center"
    >
      <el-row type="flex" class="row-bg printRow" justify="end">
        <div class="print">
          <!-- <el-button type="primary" v-print="printObj" @click="printLoadCar"
            >打印</el-button> -->
          <el-button type="primary" @click="printLoadCar">打印</el-button>
        </div>
      </el-row>

      <div id="printMe" ref="printContent">
        <div style="margin-bottom: 12px">
          <img id="barcode1" />
        </div>
        <div class="printList">
          <el-row type="flex" class="row-bg">
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <strong>出库单号:{{ outbountPrint.outboundNo }}</strong>
              </div></el-col
            >
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <strong>联系人:{{ outbountPrint.driver }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>联系电话：{{ outbountPrint.driverPhone }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>车牌号：{{ outbountPrint.carNumber }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>总箱数：{{ outbountPrint.boxCount }}</strong>
              </div></el-col
            >
          </el-row>
        </div>

        <el-table
          :data="boxPrint"
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column prop="orgReceiptNo" label="进仓单号">
          </el-table-column>
          <el-table-column prop="destination" label="目的地"></el-table-column>
          <el-table-column prop="storages" label="库位"></el-table-column>
          <el-table-column prop="orgBoxCount" label="箱数"></el-table-column>
          <el-table-column prop="boxVolumn" label="总体积"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
    <el-dialog
      id="loadingReviewdialog"
      :title="loadingReviewdialogTitle"
      :close-on-click-modal="false"
      :visible.sync="loadingReviewdialogVisible"
      class="dialogClass"
      style="text-align: center; overflow-y: hidden"
      :fullscreen="true"
    >
      <div id="completeDivd">
        <OutboundOrderSend
          v-if="loadingReviewdialogVisible"
          :outboundNoDalog="outboundNoDalog"
          @searchTable="
            () => {
              initTable();
            }
          "
          @cancelDalog="loadingReviewdialogVisible = false"
          :viewtypeDalog="viewtypeDalog"
        />

        <!-- <iframe
          :src="loadingReviewWinodw"
          width="100%"
          :height="loadingReviewWinodwheight"
          frameborder="0"
          style="overflow-x: hidden"
        ></iframe> -->
      </div>
    </el-dialog>

    <!-- 绑定 -->
    <el-dialog
      :visible.sync="addRelotion"
      v-model="addRelotion"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      :title="bingTitle"
      width="30%"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="WMS进仓号"
              prop="OrderNumber"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.OrderNumber"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="addRelotion = false">取消</el-button>
          <el-button
            type="primary"
            @click="onAddSubmit"
            :loading="addLoading"
            v-no-more-click
            >确定</el-button
          >
        </el-row>
      </el-form> 
      </el-dialog>
    <!-- 出库单详情 -->
    <OutboundOrderDetailDalog
      ref="OutboundOrderDetailDalog"
    ></OutboundOrderDetailDalog>
  </div>
</template>
<script>
import {
  getMachineReviewImages,
  getOutboundReviewImagesFileOut,
  getOutboundOrderPrint,
  outboundOrderStatusPrint,
  outboundOverPicking,
  getAreaLocation,
  JudgeOutboundInfoIsAbnormal,
  bingActualData,
  delActualData,
  getMachineListAsync,
  machineExportAsync,
} from "@/api/outbound/outboundOrder.js";
import JsBarcode from "jsbarcode";
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import { GetContainerTypeList } from "@/api/common/common.js";
import OutboundOrderSend from "./OutboundOrderSend.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import OutboundOrderDetailDalog from "./OutboundOrderDetailDalog.vue";
import selectAllVue from "../../components/TwTable/selectAll.vue";
import hoverCopy from "../../components/hoverCopy.vue";

export default {
  components: {
    LogDialog,
    TwTable,
    OutboundOrderSend,
    OutboundOrderDetailDalog,
    selectAllVue,
    hoverCopy,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      bingTitle:"",
      activeName: "0",
      outboundNoDalog: "",
      viewtypeDalog: "",
      DateTypeOptions: [
        {
          value: "a.CreateTime",
          label: "创建时间",
        },
        {
          value: "a.DeliveryDate",
          label: "预计发货时间",
        },
        {
          value: "a.ActDeliveryDate",
          label: "实际发货时间",
        },
      ],
      printObj: {
        id: "printMe",
        popTitle: "拣货单",
        extraCss: "https://www.google.com,https://www.google.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        column: [
          // 表格列配置
          {
            prop: "actualEntryDataId",
            label: "ID",
            align: "center",
            sortable: true,
            minWidth: "60",
          },
          {
            prop: "batchNo",
            label: "批次号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "orderNumber",
            label: "WMS进仓号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "bingUser",
            label: "绑定人",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "boxGui",
            label: "长宽高(CM)",
            minWidth: "150",
          },
          {
            prop: "boxVolume",
            label: "体积(CBM)",
          },
          {
            prop: "boxWeight",
            label: "重量(KG)",
          },
          {
            prop: "boxNumber",
            label: "条码",
            minWidth: "200",
          },
           {
            prop: "gridNo",
            label: "格口",
            minWidth: "70",
          },
          // {
          //   prop: "boxCount",
          //   label: "箱数",
          //   align: "center",
          //   sortable: true,
          //   minWidth: "110",
          // },
          {
            prop: "createTimeText",
            label: "测量时间",
            minWidth: "160",
          },
          {
            prop: "file",
            label: "照片",
            slot: true,
            minWidth: "120",
          },
        ],
      },
      loadingReviewWinodw: "",
      loadingReviewWinodwheight: 800,
      loadingReviewdialogVisible: false,
      organizationList: [], //客户货主
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "documentNos",
            label: "单据号",
            placeholder: "WMS进仓号",
            clearable: true,
            width: 200,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "测量时间",
            hideLabel: true,
          },
          {
            type: "input",
            key: "batchNo",
            label: "批次号",
            placeholder: "批次号",
            clearable: true,
            width: 200,
          },
          {
            type: "input",
            key: "boxNumber",
            label: "条码",
            placeholder: "条码",
            clearable: true,
            width: 200,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------
      warehouseList: [],
      transportList: [],
      locationList: [],
      statuslist: [],
      srcList: [],
      addTaskdialogVisible: false,
      outbountPrint: {},
      boxPrint: [],
      printPickListVisible: false,
      pickingOverVisible: false,
      pickingOverForm: {},
      ContainerTypeList: [],
      completeTask: "",
      loadingReviewdialogTitle: "装车单详情",
      //打托
      addFormVisible: false,
      addRelotion: false,
      addLoading: false,
      addForm: {
        actualEntryDataIds: "",
        OrderNumber: "",
      },
      addFormRules: {
        OrderNumber: [
          {
            required: true,
            message: "请输入WMS进仓单号",
            trigger: "blur",
          },
        ],
      },
    };
  },

  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    toImg() {
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight,
      }).then((canvas) => {
        // let url = canvas.toDataURL('image/jpeg', 1.0)
        const url = canvas.toDataURL();
        this.img = url;
        printJS({
          printable: url,
          type: "image",
          documentTitle: "打印装车单",
          style: "@page {margin:0 10mm};",
        });
        console.log(url);
      });
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    closeReviewdialogVisible() {
      // 关闭当前弹框
      this.loadingReviewdialogVisible = false;

      this.initTable();
    },

    relationDocument() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择测量数据！",
          type: "error",
        });
        return;
      }
      this.actualEntryDataIds= this.selectRows.rows
        .map((item) => item.actualEntryDataId)
        .join(",");
      this.bingTitle="已勾选"+row.length+"箱";
     this.addRelotion=true;
    },
    delData() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择测量数据！",
          type: "error",
        });
        return;
      }
      var actualIds= this.selectRows.rows
        .map((item) => item.actualEntryDataId)
        .join(",");
      this.$confirm(
        "确认删除设备数据[" +
          row.length +
          "]箱吗？",
        "提示",
        {}
      )
        .then(() => {
          var para = {
            actualEntryDataIds: actualIds,
          };
          delActualData(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      let row = this.sels;
      // row.forEach((item) => {
      //   this.filters.ActualEntryDataIds.push(item.actualEntryDataId);
      // });

      machineExportAsync(this.filters).then((res) => {
        loading.close();
        if (res.data.success) {
          var data = res.data.response;
          if (data != null) {
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });

          return;
        }
      });
    },

    addBoxMark(loadCarInfoID) {
      var random = Math.random();
      this.completeTask =
        "/Outbound/AddLoadingOrder?random=" +
        random +
        "&type=2&loadCarInfoID=" +
        loadCarInfoID;
      this.addTaskdialogVisible = true;
    },
    // 弹出添加出库单
    addTaskdialog() {
      this.completeTask = "/Outbound/AddOutboundOrder";
      this.addTaskdialogVisible = true;
    },
    // 弹出修改出库单
    editTaskdialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      if (this.selectRows.rows[0].outboundStatus != 10) {
        this.$message({
          message: "只能修改状态是【待拣货】的数据！",
          type: "error",
        });
        return;
      }

      let tfOutboundID = row[0].tfOutboundID;
      JudgeOutboundInfoIsAbnormal({ tfOutboundID: tfOutboundID }).then(
        (res) => {
          console.log(res);

          if (res.data.success) {
            var random = Math.random();
            this.completeTask =
              "/Outbound/AddOutboundOrder?random=" +
              random +
              "&tfOutboundID=" +
              tfOutboundID;
            this.addTaskdialogVisible = true;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    closeSelf() {
      // 关闭当前弹框
      this.addTaskdialogVisible = false;
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    resetBtn() {
      this.filters = {
      };
      this.$set(this.filters, "status", []);
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    viewloadingReviewdialog(rowData) {
      this.$refs.OutboundOrderDetailDalog.showDialog(rowData);
    },

    outboundOverSend() {
      this.loadingReviewdialogTitle = "确认出库";
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].outboundStatus != 30) {
        this.$message({
          message: "请选择状态是[待出库]的数据！",
          type: "error",
        });
        return;
      }
      this.$router.push({
        path: "/Outbound/OutboundOrderSendScan",
        query: {
          outboundNo: row[0].outboundNo,
        },
      });
      return;
    },
    //查询列表
    initTable() {
      const { documentNos, tdate, batchNo,boxNumber } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        documentNos,
        batchNo,
        boxNumber
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getMachineListAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //预览图片
    getReadyImages(id) {
      const data = {
        actualEntryDataId: id,
      };
      //this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getMachineReviewImages(data).then((res) => {
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          console.info(this.$viewer);
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id) {
      const data = {
        outboundID: id,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getOutboundReviewImagesFileOut, {
          params: data,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //打印装车单查询
    printPickList() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      getOutboundOrderPrint({ outboundID: row[0].tfOutboundID }).then((res) => {
        if (res.data.success) {
          this.printPickListVisible = true;
          this.boxPrint = res.data.response.outbountDetailList;
          this.outbountPrint = res.data.response;
          this.$nextTick(() => {
            JsBarcode("#barcode1", this.outbountPrint.outboundNo, {
              format: "CODE128", //条形码的格式
              font: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif",
              displayValue: true,
              width: 2, //线宽
              height: 90, //条码高度
              lineColor: "#000", //线条颜色
              displayValue: true, //是否显示文字
              margin: 2, //设置条形码周围的空白区域
            });
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印装车单
    printLoadCar() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      var that = this;
      outboundOrderStatusPrint({ outboundID: row[0].tfOutboundID }).then(
        (res) => {
          if (res.data.success) {
            that.toImg();
            this.initTable();
            this.printPickListVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
      getReadyforTaskBasis("").then((res) => {
        this.transportList = res.data.response.transportdata;
        this.statuslist = this.formatterOption(
          res.data.response.outboundStatusdata,
          "outboundText",
          "outboundId"
        );
      });
    },
    formatterOption(option, labelKey, valueKey) {
      return (
        option &&
        option.map((item) => {
          item.label = item[labelKey];
          item.value = item[valueKey];
          return item;
        })
      );
    },

    pickingOverSubmit() {
      const that = this;
      console.info(that.pickingOverForm);
      if (
        that.pickingOverForm.Storages == null ||
        that.pickingOverForm.Storages == ""
      ) {
        this.$message({
          message: "请输入库位",
          type: "error",
        });
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      const data = {
        TFOutboundID: that.pickingOverForm.TFOutboundID,
        OutboundNo: that.pickingOverForm.OutboundNo,
        Storages: that.pickingOverForm.Storages.join(","),
      };

      outboundOverPicking(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.pickingOverVisible = false;
          this.initTable();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    pickingOver() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      if (this.selectRows.rows[0].outboundStatus != 20) {
        this.$message({
          message: "只有[拣货中]才允许操作,请确认！",
          type: "error",
        });
        return;
      }

      this.pickingOverForm = {
        TFOutboundID: row[0].tfOutboundID,
        OutboundNo: row[0].outboundNo,
        Storages: [],
      };
      this.pickingOverVisible = true;

      const para = {
        warehouseId: row[0].warehouseId,
        area: "",
      };
      getAreaLocation(para).then((res) => {
        if (res.data.success == true) {
          this.locationList = res.data.response;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },


    //绑定
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      let _this = this;
      this.$set(para, "actualEntryDataIds", this.actualEntryDataIds);
      console.log(para);
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          var user = JSON.parse(window.localStorage.user);
          if (!user && user.id == 0) {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            _this.$router.replace(
              _this.$route.query.redirect ? _this.$route.query.redirect : "/"
            );
          }

          this.addLoading = true;
          bingActualData(para).then((res) => {
            this.addLoading = false;
            console.log(res);
            if (res.data.success) {
              this.addFormVisible = false;
              this.$refs["addRuleForm"].resetFields();
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    let user = JSON.parse(window.localStorage.user);
    this.organizationList = user.organizationList;
    this.getBasicdatalist();
  },
};
</script>

<style lang="less">
.content-az {
  overflow-x: hidden;
}
.printDalog {
  .el-dialog__body {
    padding-top: 0;
  }
}
.printRow {
  position: absolute;
  right: 20px;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
.printList {
  font-size: 16px;
  margin-bottom: 14px;
}
#completeDivd {
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
}
</style>

<style type="text/css" media="print">
@page {
  size: landscape;
}
</style>

<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>